import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: false,
  token: null,
  id: null,
  isExpand: true, // Always starts collapsed
  useremail:null,
  name:null,
  userRoles:[]
};
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.id = action.payload.id;
      state.useremail = action.payload.useremail;
      state.name = action.payload.name;
      state.isExpand = action.payload.isExpand ?? true; 
      state.userRoles = action.payload.userRoles; 
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.id = null;
      state.isExpand = true;
    },
    toggleSidebar: (state) => {
      state.isExpand = !state.isExpand; 
    },
    resetState: (state) => {
      state.isExpand = true; 
    },
    userRoles: (state, action) => {  // Add this reducer to manage user roles separately
      state.userRoles = action.payload;
    },
  },
});

export const { loginSuccess, logout, toggleSidebar, resetState, userRoles } = authSlice.actions;
export default authSlice.reducer;